/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_TermsInputs */

const en_footer_link_terms = /** @type {(inputs: Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const es_footer_link_terms = /** @type {(inputs: Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos de servicio`)
};

const fr_footer_link_terms = /** @type {(inputs: Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conditions d'utilisation`)
};

const de_footer_link_terms = /** @type {(inputs: Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsbedingungen`)
};

const ja_footer_link_terms = /** @type {(inputs: Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用規約`)
};

const zh_footer_link_terms = /** @type {(inputs: Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务条款`)
};

const ar_footer_link_terms = /** @type {(inputs: Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شروط الخدمة`)
};

const id_footer_link_terms = /** @type {(inputs: Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persyaratan Layanan`)
};

const it_footer_link_terms = /** @type {(inputs: Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termini di Servizio`)
};

const ru_footer_link_terms = /** @type {(inputs: Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия предоставления услуг`)
};

const pt_footer_link_terms = /** @type {(inputs: Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos de Serviço`)
};

const ko_footer_link_terms = /** @type {(inputs: Footer_Link_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서비스 이용약관`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Footer_Link_TermsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_link_terms = /** @type {((inputs?: Footer_Link_TermsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_TermsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_link_terms(inputs)
	if (locale === "es") return es_footer_link_terms(inputs)
	if (locale === "fr") return fr_footer_link_terms(inputs)
	if (locale === "de") return de_footer_link_terms(inputs)
	if (locale === "ja") return ja_footer_link_terms(inputs)
	if (locale === "zh") return zh_footer_link_terms(inputs)
	if (locale === "ar") return ar_footer_link_terms(inputs)
	if (locale === "id") return id_footer_link_terms(inputs)
	if (locale === "it") return it_footer_link_terms(inputs)
	if (locale === "ru") return ru_footer_link_terms(inputs)
	if (locale === "pt") return pt_footer_link_terms(inputs)
	return ko_footer_link_terms(inputs)
});